import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { useState as I, useRef as U, useCallback as w, useEffect as D } from "react";
/*! js-cookie v3.0.1 | MIT */

function h(e) {
  for (var n = 1; n < arguments.length; n++) {
    var o = arguments[n];

    for (var u in o) {
      e[u] = o[u];
    }
  }

  return e;
}

var V = {
  read: function read(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function write(e) {
    return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
};

function L(e, n) {
  function o(t, v, r) {
    if (!(typeof document > "u")) {
      r = h({}, n, r), typeof r.expires == "number" && (r.expires = new Date(Date.now() + r.expires * 864e5)), r.expires && (r.expires = r.expires.toUTCString()), t = encodeURIComponent(t).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var a = "";

      for (var c in r) {
        !r[c] || (a += "; " + c, r[c] !== !0 && (a += "=" + r[c].split(";")[0]));
      }

      return document.cookie = t + "=" + e.write(v, t) + a;
    }
  }

  function u(t) {
    if (!(typeof document > "u" || arguments.length && !t)) {
      for (var v = document.cookie ? document.cookie.split("; ") : [], r = {}, a = 0; a < v.length; a++) {
        var c = v[a].split("="),
            m = c.slice(1).join("=");

        try {
          var g = decodeURIComponent(c[0]);
          if (r[g] = e.read(m, g), t === g) break;
        } catch (_unused) {}
      }

      return t ? r[t] : r;
    }
  }

  return Object.create({
    set: o,
    get: u,
    remove: function remove(t, v) {
      o(t, "", h({}, v, {
        expires: -1
      }));
    },
    withAttributes: function withAttributes(t) {
      return L(this.converter, h({}, this.attributes, t));
    },
    withConverter: function withConverter(t) {
      return L(h({}, this.converter, t), this.attributes);
    }
  }, {
    attributes: {
      value: Object.freeze(n)
    },
    converter: {
      value: Object.freeze(e)
    }
  });
}

var C = L(V, {
  path: "/"
});

function j() {
  return typeof window < "u";
}

function y() {
  if (j()) return window.matchMedia("(hover: none)").matches || navigator.userAgent.toLowerCase().includes("mobile");
}

function B() {
  if (j()) return !y();
}

function M(e) {
  var n, o;
  var u = (n = e.context) == null ? void 0 : n.includes("onDesktop"),
      t = (o = e.context) == null ? void 0 : o.includes("onMobile");
  !u && !t && e.handler(), u && B() && e.handler(), t && y() && e.handler();
}

function R(e) {
  return e * 1e3;
}

function P(e) {
  k(e), window.addEventListener("load", e, !0), window.addEventListener("mousemove", e, !0), window.addEventListener("mousedown", e, !0), window.addEventListener("keydown", e, !0), window.addEventListener("touchstart", e, !0), window.addEventListener("click", e, !0), window.addEventListener("scroll", e, !0);
}

function k(e) {
  window.removeEventListener("load", e, !0), window.removeEventListener("mousemove", e, !0), window.removeEventListener("mousedown", e, !0), window.removeEventListener("keydown", e, !0), window.removeEventListener("touchstart", e, !0), window.removeEventListener("click", e, !0), window.removeEventListener("scroll", e, !0);
}

function A(e) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var o;
  return {
    execute: function execute(u) {
      clearTimeout(o), o = setTimeout(function () {
        return e(u);
      }, n);
    },
    abort: function abort() {
      clearTimeout(o);
    }
  };
}

var T = {
  onMobile: "onMobile",
  onTrigger: "onTrigger",
  onDesktop: "onDesktop",
  onUnsubscribe: "onUnsubscribe"
},
    E = {
  cookie: {
    daysToExpire: 30,
    key: "exit-intent"
  },
  desktop: {
    triggerOnIdle: !1,
    useBeforeUnload: !1,
    triggerOnMouseLeave: !0,
    delayInSecondsToTrigger: 10
  },
  mobile: {
    triggerOnIdle: !0,
    delayInSecondsToTrigger: 10
  }
};

var W = Object.defineProperty,
    X = Object.defineProperties,
    Y = Object.getOwnPropertyDescriptors,
    F = Object.getOwnPropertySymbols,
    Z = Object.prototype.hasOwnProperty,
    _ = Object.prototype.propertyIsEnumerable,
    z = function z(e, n, o) {
  return n in e ? W(e, n, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: o
  }) : e[n] = o;
},
    l = function l(e, n) {
  for (var o in n || (n = {})) {
    Z.call(n, o) && z(e, o, n[o]);
  }

  if (F) {
    var _iterator = _createForOfIteratorHelper(F(n)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var o = _step.value;
        _.call(n, o) && z(e, o, n[o]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return e;
},
    S = function S(e, n) {
  return X(e, Y(n));
};

function $() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var n = S(l({}, E), {
    cookie: l(l({}, E.cookie), e === null || e === void 0 ? void 0 : e.cookie),
    desktop: l(l({}, E.desktop), e === null || e === void 0 ? void 0 : e.desktop),
    mobile: l(l({}, E.mobile), e === null || e === void 0 ? void 0 : e.mobile)
  }),
      _I = I(n),
      _I2 = _slicedToArray(_I, 2),
      o = _I2[0],
      u = _I2[1],
      _I3 = I(!1),
      _I4 = _slicedToArray(_I3, 2),
      t = _I4[0],
      v = _I4[1],
      _I5 = I(!1),
      _I6 = _slicedToArray(_I5, 2),
      r = _I6[0],
      a = _I6[1],
      c = U([]).current,
      m = U(!1),
      g = o.mobile,
      f = o.desktop,
      p = o.cookie,
      H = !(r || t);

  m.current = r || t;
  var b = w(function () {
    m.current || (v(!0), c.filter(function (d) {
      var i, s;
      return ((i = d.context) == null ? void 0 : i.filter(function (x) {
        return x !== T.onDesktop && x !== T.onMobile;
      }).length) === 0 || ((s = d.context) == null ? void 0 : s.includes(T.onTrigger));
    }).forEach(M));
  }, []),
      q = w(function () {
    C.set(p.key, "true", {
      expires: p.daysToExpire,
      sameSite: "Strict"
    }), c.filter(function (d) {
      var i;
      return (i = d.context) == null ? void 0 : i.includes(T.onUnsubscribe);
    }).forEach(M), a(!0);
  }, [p === null || p === void 0 ? void 0 : p.key]),
      O = w(function () {
    C.remove(p === null || p === void 0 ? void 0 : p.key, {
      sameSite: "Strict"
    }), window.onbeforeunload = null, v(!1), a(!1);
  }, [p === null || p === void 0 ? void 0 : p.key]),
      G = w(function () {
    O(), u(n);
  }, []),
      J = w(function (d) {
    var i = c.find(function (x) {
      return x.id === d.id;
    }),
        s = S(l({}, d), {
      context: (d === null || d === void 0 ? void 0 : d.context) || []
    });

    if (i) {
      c[c.indexOf(i)] = s;
      return;
    }

    c.push(s);
  }, []),
      Q = w(function () {
    var d = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : E;
    var i = d;
    O(), u(function (s) {
      return S(l(l({}, s || {}), i || {}), {
        cookie: l(l({}, (s === null || s === void 0 ? void 0 : s.cookie) || {}), (i === null || i === void 0 ? void 0 : i.cookie) || {}),
        desktop: l(l({}, (s === null || s === void 0 ? void 0 : s.desktop) || {}), (i === null || i === void 0 ? void 0 : i.desktop) || {}),
        mobile: l(l({}, (s === null || s === void 0 ? void 0 : s.mobile) || {}), (i === null || i === void 0 ? void 0 : i.mobile) || {})
      });
    });
  }, [o]);
  return D(function () {
    a(C.get(p.key) === "true");
  }, []), D(function () {
    if (y()) {
      var _A = A(b, R(g === null || g === void 0 ? void 0 : g.delayInSecondsToTrigger)),
          d = _A.execute,
          i = _A.abort;

      if (m.current) {
        k(d);
        return;
      }

      return y() && g !== null && g !== void 0 && g.triggerOnIdle && (k(d), P(d)), function () {
        i(), k(d);
      };
    }

    if (B()) {
      var _A2 = A(b, R(f === null || f === void 0 ? void 0 : f.delayInSecondsToTrigger)),
          _d = _A2.execute,
          _i = _A2.abort;

      return f != null && f.triggerOnIdle && P(_d), f != null && f.triggerOnMouseLeave && document.body.addEventListener("mouseleave", b), f != null && f.useBeforeUnload && (window.onbeforeunload = function () {
        if (!m.current) return b(), "";
      }), function () {
        _i(), k(_d), document.body.removeEventListener("mouseleave", b);
      };
    }
  }), {
    settings: o,
    resetState: O,
    isTriggered: t,
    unsubscribe: q,
    resetSettings: G,
    updateSettings: Q,
    isUnsubscribed: r,
    registerHandler: J,
    willBeTriggered: H
  };
}

export { $ as useExitIntent };